import { IconAlertTriangle, IconCheckmarkCircleFill, IconClose, IconInfo } from "@synthesis/shared-icons";
import { cn } from "@synthesis/shared-utils";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/NoticeBase/index.tsx
const hasNoticeTitle = (title) => {
	if (title == null || typeof title === "boolean") return false;
	if (typeof title === "string") return title.trim().length > 0;
	return true;
};
const statusConfig = {
	success: {
		container: "bg-system-success-90",
		icon: "text-system-success-50",
		title: "text-system-success-50",
		Icon: IconCheckmarkCircleFill
	},
	error: {
		container: "bg-system-error-90",
		icon: "text-system-error-50",
		title: "text-system-error-50",
		Icon: IconAlertTriangle
	},
	info: {
		container: "bg-system-info-90",
		icon: "text-system-info-50",
		title: "text-system-info-50",
		Icon: IconInfo
	},
	pending: {
		container: "bg-system-attention-90",
		icon: "text-system-attention-50",
		title: "text-system-attention-50",
		Icon: IconAlertTriangle
	}
};
const noticeDescriptionClassName = "text-type-minor text-sm font-normal leading-5";
/** Design-system subtitle-lg: Inter Medium 18/24 */
const noticeTitleClassName = "subtitle-lg";
const NoticeBase = ({ status, title, description, type = "ordinary", icon: IconOverride, onClose, className, titleAppearance = "status" }) => {
	const { container, icon, title: titleStatusClassName, Icon: DefaultIcon } = statusConfig[status];
	const Icon = IconOverride ?? DefaultIcon;
	const showTitle = hasNoticeTitle(title);
	const titleClassName = titleAppearance === "plain" ? noticeDescriptionClassName : cn(noticeTitleClassName, titleAppearance === "common" ? "text-type-common" : titleStatusClassName);
	return /* @__PURE__ */ jsxs("div", {
		role: "status",
		className: cn("relative flex w-full gap-3", onClose && "pr-10", type === "bubble" ? "max-w-[480px] rounded-[28px] px-5 py-4" : "rounded-2xl px-4 py-4", container, className),
		children: [
			/* @__PURE__ */ jsx(Icon, {
				className: cn("mt-px size-5 shrink-0", icon),
				"aria-hidden": true
			}),
			/* @__PURE__ */ jsxs("div", {
				className: "min-w-0 flex-1",
				children: [showTitle ? /* @__PURE__ */ jsx("p", {
					className: titleClassName,
					children: title
				}) : null, description ? /* @__PURE__ */ jsx("p", {
					className: cn(noticeDescriptionClassName, showTitle && "mt-1"),
					children: description
				}) : null]
			}),
			onClose ? /* @__PURE__ */ jsx("button", {
				type: "button",
				"aria-label": "Закрыть уведомление",
				onClick: onClose,
				className: "text-neutrals-50 hover:text-neutrals-30 focus-visible:outline-system-info-70 absolute right-3 top-3 flex size-5 items-center justify-center outline-none focus-visible:outline focus-visible:outline-2",
				children: /* @__PURE__ */ jsx(IconClose, { className: "size-4" })
			}) : null
		]
	});
};
//#endregion
export { NoticeBase };

//# sourceMappingURL=index.js.map